import { render, staticRenderFns } from "./studentExam.vue?vue&type=template&id=24bb660e&scoped=true"
import script from "./studentExam.vue?vue&type=script&lang=js"
export * from "./studentExam.vue?vue&type=script&lang=js"
import style0 from "./studentExam.vue?vue&type=style&index=0&id=24bb660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb660e",
  null
  
)

export default component.exports